import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'ucfirst',
  standalone: false,
})
export class UCFirstPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value
    }
    if (typeof value !== 'string') {
      throw new Error('invalid uc first argument, expect a string')
    }
    return value[0].toUpperCase() + value.substr(1)
  }
}
